export interface Ages {
  actualAge: number;
  insuredAge: number;
}

export class AgeUtils {
  /**
   * Calculates the applicant's age, by the common definition.
   */
  static getActualAge(birthDate: Date | string): number {
    const today = new Date();
    const normalizedBirthDate = new Date(birthDate);

    let age = today.getFullYear() - normalizedBirthDate.getFullYear();
    const m = today.getMonth() - normalizedBirthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < normalizedBirthDate.getDate())) {
      age--;
    }
    return age;
  }

  /**
   * Calculate number of days between dates
   */
  static daysBetween(fromDate: Date, toDate: Date): number {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (toDate.getTime() - fromDate.getTime()) / millisecondsPerDay;
  }

  /**
   * Calculate if it is midyear to current date
   */
  static halfYearCorrection(birthDate: Date | string): number {
    const birthdayElems = String(birthDate).split('/');
    const todayDateObject = new Date();
    birthdayElems[2] = todayDateObject.getFullYear().toString();
    const currBirthday = new Date(birthdayElems.join('/'));
    const currBirthdayDistance = AgeUtils.daysBetween(todayDateObject, currBirthday);
    const isNextYear = currBirthdayDistance < -183 || (currBirthdayDistance > 0 && currBirthdayDistance < 183);
    return isNextYear ? 1 : 0;
  }

  /**
   * Calculates the applicant's insurance age.
   */
  static getInsuranceAge(birthDate: Date | string): number {
    const actualAge = AgeUtils.getActualAge(birthDate);
    return actualAge + AgeUtils.halfYearCorrection(birthDate);
  }

  /**
   * Returns both the applicant's actual age and insurance age.
   */
  static getAges(birthDate: Date | string): Ages {
    const calculatedAges: Ages = {
      actualAge: AgeUtils.getActualAge(birthDate),
      insuredAge: AgeUtils.getInsuranceAge(birthDate),
    };

    return calculatedAges;
  }
}
